import { createSlice } from '@reduxjs/toolkit';
import { getAllPrompts } from './promptDetailsAction';

export const promptSlice = createSlice({
  name: 'promptDetail',
  initialState: {
    loading: false,
    data: [],
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllPrompts.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllPrompts.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message || '';
      state.error = null;
    });
    builder.addCase(getAllPrompts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});

